import { z } from "zod";
import { BladeCommonSchema } from "../common";
import { BackdropSchema, BladeHeaderSchema, CharacterMoveSchema, LinksGroupSchema, RichTextSchema, VisualMediaSchema, } from "../../fragments";
const _baseRecursiveGroupedCharacterMovesSchema = z.object({
    label: z.string().optional(),
    thumbnail: VisualMediaSchema.optional(),
    color: z.string().optional(),
    description: RichTextSchema.optional(),
});
export const RecursiveGroupedCharacterMoveSchema = _baseRecursiveGroupedCharacterMovesSchema.extend({
    content: z.array(z.object({
        item: CharacterMoveSchema,
        groups: z.lazy(() => z.array(RecursiveGroupedCharacterMoveSchema).optional()),
    })),
});
export const CharacterMovesListBladeTypeValues = ["characterMovesList"];
export const CharacterMovesListBladeTypesSchema = z.enum(CharacterMovesListBladeTypeValues);
export const CharacterMovesListBladeTypes = CharacterMovesListBladeTypesSchema.enum;
export const CharacterMovesListBladeSchema = BladeCommonSchema.extend({
    backdrop: BackdropSchema.optional(),
    header: BladeHeaderSchema.optional(),
    groups: z.array(RecursiveGroupedCharacterMoveSchema),
    linksGroup: LinksGroupSchema.optional(),
});
export const CharacterMovesListBladesContractSchema = CharacterMovesListBladeSchema.extend({
    type: CharacterMovesListBladeTypesSchema,
});
export const CharacterMovesListContractSchema = CharacterMovesListBladeSchema.extend({
    type: z.literal(CharacterMovesListBladeTypes.characterMovesList),
});
//# sourceMappingURL=index.js.map